import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { AppSidebar } from '@/components/shell/app-sidebar'
import { MobileTabBar } from '@/components/shell/mobile-tabbar'
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar'
import { meQuery } from '@/lib/session'
import { Mark } from '@/components/brand/logo'

export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    const me = await context.queryClient.ensureQueryData(meQuery)
    if (!me) throw redirect({ to: '/login', search: { redirect: location.href } })
    if (me.mustChangePassword) throw redirect({ to: '/change-password' })
    return { me }
  },
  component: AppLayout,
})

function AppLayout() {
  const { me } = Route.useRouteContext()
  return (
    <SidebarProvider defaultOpen={typeof window === 'undefined' || window.innerWidth >= 1024}>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:rounded-md focus:bg-card focus:px-3 focus:py-2"
      >
        Skip to content
      </a>
      <AppSidebar user={me} />
      <SidebarInset className="min-w-0 bg-background">
        <header className="sticky top-0 z-30 flex h-14 items-center gap-3 border-b bg-background/90 px-4 backdrop-blur md:hidden">
          <Mark className="size-7 text-ink dark:text-white" />
          <span className="font-semibold [font-stretch:88%]">HCD Portal</span>
        </header>
        <div className="hidden h-12 items-center px-4 md:flex">
          <SidebarTrigger className="text-muted-foreground" />
        </div>
        <main
          id="main"
          className="mx-auto w-full max-w-6xl px-4 pt-4 pb-28 sm:px-6 md:pt-2 md:pb-12 lg:px-10"
        >
          <Outlet />
        </main>
      </SidebarInset>
      <MobileTabBar />
    </SidebarProvider>
  )
}
